export default class InterestVariation {

	constructor(id, paymentDateIndex, interest) {
		this.id               = id
		this.paymentDateIndex = paymentDateIndex
		this.interest         = interest
	}
	
	static createFromJson(json) {
		if (!json) return null;
		return new InterestVariation(json.id, json.paymentDateIndex, json.interest);
	}
}


// WEBPACK FOOTER //
// ./src/model/interest-variation.js